import React from 'react';
import { withStyles, Typography } from '@material-ui/core';

const styles = {
  wrapper: {
    marginTop: '25px',
    marginBottom: '24px',
  },
  titleWrapper:{
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    margin: '0',
    lineHeight: '30px',
  },
  subTitle: {
    color: '#8E8F8E',
    margin: '13px 0 0',
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'none',
    fontWeight: 400
  }
}

const TabHeader = (props) => {
  const {title, subTitle, classes, children} = props;
  return (
    <div className={classes.wrapper}>
      <div className={classes.titleWrapper}>
        <Typography variant="h5" className={classes.title}>
          {title}
        </Typography>
        {children}
      </div>
      {subTitle ?
        <Typography variant="subtitle1" className={classes.subTitle}>
          {subTitle}
        </Typography>
        : null}
    </div>
  )
}

export default withStyles(styles)(TabHeader)
